export default {
    apiKey: "AIzaSyBQYLIuuZm-1vYUhpCxLgYvqjE3eBA3GV8",
    authDomain: "appiedesenvolvimentos-2d7f9.firebaseapp.com",
    projectId: "appiedesenvolvimentos-2d7f9",
    storageBucket: "appiedesenvolvimentos-2d7f9.appspot.com",
    messagingSenderId: "893703954459",
    appId: "1:893703954459:web:483027181d27e6394458be"
  }